<template>
    <!-- eslint-disable max-len -->
    <div
        class="widget-example"
        :class="{
            'widget-example--sidebar': state === 'sidebar',
            'widget-example--popup': state === 'popup',
            'widget-example--inline': state === 'inline',
        }"
    >
        <svg width="328px" height="159px" viewBox="0 0 328 159" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Mobile-Step-1-Copy" transform="translate(-17.000000, -1222.000000)" fill-rule="nonzero">
                    <g id="Widget-settings" transform="translate(16.000000, 992.000000)">
                        <g id="Pop-up" transform="translate(1.000000, 185.000000)">
                            <g id="Content" transform="translate(0.000000, 45.000000)">
                                <g id="Image">
                                    <rect id="Rectangle" fill="#F2F5F7" x="0" y="0" width="158.592275" height="158.70255" rx="4"></rect>
                                    <g id="Group" transform="translate(27.805139, 38.478259)" fill="#E5EBEF">
                                        <g id="picture">
                                            <path d="M12.5130742,71.0056771 C12.9287891,71.0056771 13.348057,70.8603059 13.6856033,70.5642452 L42.666615,45.1030188 L60.9687287,63.3648272 C61.6633634,64.0579995 62.7861489,64.0579995 63.4807836,63.3648272 C64.1754183,62.671655 64.1754183,61.5512334 63.4807836,60.8580612 L54.9408631,52.3361203 L71.2514539,34.5121982 L91.257288,52.8130086 C91.9803477,53.4742701 93.1049097,53.4246312 93.7675663,52.7030938 C94.4302229,51.9815565 94.3822558,50.8593621 93.6574196,50.1981006 L72.3387082,30.6970917 C71.9905026,30.3797571 71.5268206,30.2219762 71.0595855,30.2326131 C70.5887973,30.253887 70.1446575,30.4613068 69.8266534,30.8087793 L52.4270317,49.8258086 L44.000811,41.4173282 C43.3363778,40.7560667 42.2739954,40.7223831 41.5704779,41.3393241 L11.3387685,67.901471 C10.6014964,68.54855 10.530434,69.6689716 11.1788782,70.4046915 C11.5306369,70.8035757 12.0209673,71.0056771 12.5130742,71.0056771 Z" id="Shape"></path>
                                        </g>
                                        <path d="M23.5023933,25.4618787 C30.0379236,25.4618787 35.3540275,20.112023 35.3540275,13.5371403 C35.3540275,6.95797434 30.0379236,1.60811865 23.5023933,1.60811865 C16.9668629,1.60811865 11.6507591,6.95797434 11.6507591,13.5349987 C11.6507591,20.112023 16.9668629,25.4618787 23.5023933,25.4618787 Z M23.5023933,5.89142985 C27.6905808,5.89142985 31.0977394,9.32236212 31.0977394,13.5349987 C31.0977394,17.7476352 27.6905808,21.1785675 23.5023933,21.1785675 C19.3142058,21.1785675 15.9070472,17.7497769 15.9070472,13.5371403 C15.9070472,9.32450377 19.3142058,5.89142985 23.5023933,5.89142985 Z" id="Shape"></path>
                                        <rect id="Rectangle" x="20.2214324" y="28.678116" width="6.69583854" height="6.70049439" rx="3.34791927"></rect>
                                    </g>
                                </g>
                                <g transform="translate(168.478547, 0.000000)">
                                    <rect id="Rectangle-Copy" fill="#E5EBEF" x="0" y="0" width="158.592275" height="12.3664325" rx="6.18321623"></rect>
                                    <rect id="Rectangle-Copy-2" fill="#F2F5F7" x="0" y="71.7253082" width="49.4313584" height="12.3664325" rx="6.18321623"></rect>
                                    <rect id="Rectangle-Copy-5" fill="#F2F5F7" x="0" y="145.923903" width="49.4313584" height="12.3664325" rx="6.18321623"></rect>
                                    <g id="Group-2" transform="translate(0.000000, 103.465818)">
                                        <rect id="Rectangle-Copy-3" fill="#F2F5F7" x="0" y="0" width="49.4313584" height="23.0840072" rx="11.5420036"></rect>
                                        <rect id="Rectangle-Copy-4" fill="#E5EBEF" x="54.5804583" y="0" width="49.4313584" height="23.0840072" rx="11.5420036"></rect>
                                    </g>
                                    <g id="Stars" transform="translate(0.000000, 24.050755)" fill="#E5EBEF">
                                        <ellipse id="Oval" cx="7.20873977" cy="7.21375226" rx="7.20873977" ry="7.21375226"></ellipse>
                                        <ellipse id="Oval-Copy" cx="31.512491" cy="7.21375226" rx="7.20873977" ry="7.21375226"></ellipse>
                                        <ellipse id="Oval-Copy-2" cx="55.8162422" cy="7.21375226" rx="7.20873977" ry="7.21375226"></ellipse>
                                        <ellipse id="Oval-Copy-3" cx="80.1199934" cy="7.21375226" rx="7.20873977" ry="7.21375226"></ellipse>
                                        <ellipse id="Oval-Copy-4" cx="104.423745" cy="7.21375226" rx="7.20873977" ry="7.21375226"></ellipse>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
        <div
            class="widget-example__location widget-example__location--sidebar"
            :class="{
                'widget-example__location--showing': state === 'sidebar',
            }"
        ></div>
        <div
            class="widget-example__location widget-example__location--popup"
            :class="{
                'widget-example__location--showing': state === 'popup',
            }"
        ></div>
    </div>
</template>

<script>
// eslint-disable-line max-len
export default {
    name: 'WidgetExample',
    props: {
        state: {
            type: String,
            default: 'sidebar',
        },
    },
};
</script>

<style scoped lang="scss">
@import "./src/style_variables/style_variables";
.widget-example {
    width: 100%;
    height: 248px;
    background-color: $grey07;
    position: relative;
    overflow: hidden;
    transition: all 0.5s ease;
    padding-top: 56.25%; // 16:9 Aspect Ratio.

    svg {
        position: absolute;
        top: 0px;
        width: 70%;
        height: 100%;
        transform: translate(0%, 0%);
        transition: all 0.5s ease;
        will-change: width;
    }
}
.widget-example--sidebar {
    svg {
        width: 100%;
        transform: translate(0%, 5%);
    }
}
.widget-example--popup {
    svg {
        width: 100%;
        transform: translate(0%, 5%);
    }
}
.widget-example--inline {
    height: 420px;
    svg {
        height: 240px;
    }
}
.widget-example__location {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 25%;
    height: 100%;
    border-radius: 6px;
    background-color: $green;
    box-shadow: 0 3px 10px 0 rgba(110,220,177,0.50);
    transform: translate(0px, 0px) translateZ(1);
    will-change: right, top, width, height;
    transition: all 0.42s ease;


    &.widget-example__location--sidebar {
        right: -26%;
        opacity: 1;
        &.widget-example__location--showing {
            opacity: 1;
            right: 0%;
        }
    }
    &.widget-example__location--popup {
        height: 90%;
        width: 45%;
        right: 50%;
        transform: translate(50%, 5%) scale(0.68);
        opacity: 0;
        &.widget-example__location--showing {
            transform: translate(50%, 5%) scale(1);
            opacity: 1;
        }
    }
    &.widget-example__location--inline {
        width: 45%;
        height: 50%;
        top: 45%;
        right: 20%;
    }
}
</style>
